module.exports = __webpack_public_path__ + "img/Husky.c50262f6.png";